import { create } from "zustand";
import { Preferences } from "@capacitor/preferences";

// Klíč se mění každý den → automatické vyčištění druhý den
const storageKey = () => `routera.storno.acked.${new Date().toISOString().slice(0, 10)}`;

function parseIds(raw: string | null): Set<string> {
  try { if (raw) return new Set(JSON.parse(raw) as string[]); } catch { /* ignore */ }
  return new Set();
}

// Synchronní init z localStorage (pro okamžitý první render)
function loadAckedSync(): Set<string> {
  try { return parseIds(localStorage.getItem(storageKey())); } catch { return new Set(); }
}

async function saveAcked(ids: Set<string>): Promise<void> {
  const serialized = JSON.stringify([...ids]);
  // Zapsat do obou — localStorage pro sync čtení, Preferences pro přežití kill
  try { localStorage.setItem(storageKey(), serialized); } catch { /* ignore */ }
  try { await Preferences.set({ key: storageKey(), value: serialized }); } catch { /* ignore */ }
}

interface StornoAckStore {
  ackedIds: Set<string>;
  ack: (stopId: string) => void;
  isAcked: (stopId: string) => boolean;
  /** Zavolat při startu app — načte Preferences (spolehlivější než localStorage na Android) */
  hydrate: () => Promise<void>;
  /** Reset při přihlášení/odhlášení — odkliknutá storna patří konkrétnímu řidiči. */
  reset: () => Promise<void>;
}

export const useStornoAckStore = create<StornoAckStore>((set, get) => ({
  ackedIds: loadAckedSync(),

  ack: (stopId) => {
    const next = new Set(get().ackedIds);
    next.add(stopId);
    void saveAcked(next);
    set({ ackedIds: next });
  },

  isAcked: (stopId) => get().ackedIds.has(stopId),

  hydrate: async () => {
    try {
      const { value } = await Preferences.get({ key: storageKey() });
      if (value) {
        const ids = parseIds(value);
        if (ids.size > 0) set({ ackedIds: ids });
      }
    } catch { /* ignore */ }
  },

  reset: async () => {
    set({ ackedIds: new Set() });
    try { localStorage.removeItem(storageKey()); } catch { /* ignore */ }
    try { await Preferences.remove({ key: storageKey() }); } catch { /* ignore */ }
  },
}));
